import { Product } from 'army-builder-shared';

export const sortCardPacks = (a: Product, b: Product): number => {
    if (a.key === 'all_access') {
        return -1;
    }
    if (b.key === 'all_access') {
        return 1;
    }

    let aKey = a.key;
    let bKey = b.key;

    if (a.bundles?.length > 0 && !b.bundles?.length) {
        if (a.bundles.includes(b.key)) {
            return 1;
        }
        aKey = a.bundles[0];
    }

    if (b.bundles?.length > 0 && !a.bundles?.length) {
        if (b.bundles.includes(a.key)) {
            return -1;
        }
        bKey = b.bundles[0];
    }

    if (aKey.includes('wave') && !bKey.includes('wave')) {
        return -1;
    }

    if (bKey.includes('wave') && !aKey.includes('wave')) {
        return 1;
    }

    const pattern = /^wave_(\d*)$/;
    const aMatches = aKey.match(pattern);
    const bMatches = bKey.match(pattern);
    if (aMatches?.length > 0 && bMatches?.length > 0) {
        const aWave = parseInt(aMatches[1]);
        const bWave = parseInt(bMatches[1]);
        return aWave - bWave;
    }

    return aKey.localeCompare(bKey);
};
